<ez-header [imageData]="headerConfig()" [organisationName]="organisation()?.name" />
<ng-content select="ez-stepper"></ng-content>
<ng-content select="ez-banner"></ng-content>

<div class="page-content">
  <ng-content></ng-content>
</div>

@if (organisation(); as _organisation) {
  <div class="block--centered" id="contactButton">
    <ez-contact
      [mainLogoUrl]="mainLogoUrl()"
      [smallLogoUrl]="smallLogoUrl()"
      [companyName]="_organisation.shortName"
      [companyAddress]="_organisation.address"
      [companyPhone]="_organisation.contactInfo.phone"
      [companyEmail]="_organisation.contactInfo.email"
      [companyWeb]="_organisation.web.homepageUrl"
    />
  </div>
}

<div class="footer">
  <a class="dataPrivacy" target="_blank" rel="noopener noreferrer" [href]="dataProtectionUrl()">Datenschutz</a>
  <a class="imprint" target="_blank" rel="noopener noreferrer" [href]="imprintUrl()">Impressum</a>
  @if (showWithdrawalLink() && withdrawalUrl()) {
    <a class="withdrawal" target="_blank" rel="noopener noreferrer" [href]="withdrawalUrl()">Vertrag widerrufen</a>
  }
</div>
